export default {
  hasNewNativeAppVersion: (state) => {
    return !!state.appUpdateInfo?.updateAvailable;
  },
};
